import React, { useEffect } from "react";
import { DA_Button } from "@danishagro/shared/src/components/atoms/Button/Button.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { SSH_Role } from "@danishagro/sharedShop/src/interfaces/role.interface";
import { SSH_Scope } from "@danishagro/sharedShop/src/interfaces/scope.interface";
import { SSH_ScopeGroup } from "@danishagro/sharedShop/src/interfaces/scopeGroup.interface";
import S from "./InviteTypeBottomSheet.module.scss";

interface InviteTypeModalProps {
    role: string;
    roles: SSH_Role[];
    scopes: SSH_Scope[];
    scopeGroups: SSH_ScopeGroup[];
    openInvite: () => void;
}

export const _InviteTypeBottomSheet = (props: InviteTypeModalProps) => {
    const { getDictionaryString } = useTranslations();

    useEffect(() => {
        props.openInvite();
        // Optionally, if you want to close this bottom sheet immediately, add code here to dismiss it if needed.
    }, [props]);

    const categorizedScopes = {};
    props.scopeGroups.forEach((group) => {
        categorizedScopes[group.alias] = props.scopes.filter(
            (scope) => scope.group === group.alias
        );
    });

    return (
        <>
            <div className={S.scopeContainer}>
                <div className={S.scopeColumn}>
                    <h2>
                        {`${getDictionaryString("Invite")}, ${getDictionaryString(props.role)}`}
                    </h2>
                </div>
            </div>

            <div className={S.buttonWrapper}>
                <DA_Button
                    title={getDictionaryString("inviteType", {
                        type: getDictionaryString(props.role),
                    })}
                    onClick={() => props.openInvite()}
                    className={S.primary}
                />
            </div>
        </>
    );
};
